<template>
  <b-modal
    :active.sync="showModal"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(exportReport)">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Choose Date Range</p>
          </header>
          <section class="modal-card-body">
            <div class="columns is-multiline">
              <div class="column is-6">
                <BaseDatePicker
                  v-model="criteria.start_time"
                  label="Start Date"
                  :rules="'required'"
                >
                </BaseDatePicker>
              </div>
              <div class="column is-6">
                <BaseDatePicker
                  v-model="criteria.end_time"
                  label="End Date"
                  :rules="'required'"
                  :min-datetime="criteria.start_time"
                >
                </BaseDatePicker>
              </div>
              <div class="column is-6">
                <BaseSelect
                  v-model="criteria.channel"
                  label="Channel"
                  :rules="'required'"
                >
                  <option v-for="channel in channels" :value="channel">
                    {{ channel.name }}
                  </option>
                </BaseSelect>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot" style="display: block">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button
              class="button is-primary"
              :loading="loading"
              @click.prevent="passes(exportReport)"
            >
              Export
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import BaseDatePicker from '@/components/BaseDatePicker'
import BaseSelect from '@/components/BaseSelect'
import ScheduleApi from '@/api/schedules'
import ChannelApi from '@/api/channels'

export default {
  name: 'ExportCatchupScheduleModal',
  components: {
    BaseDatePicker,
    BaseSelect
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      initialized: false,
      showModal: this.show,
      channels: [],
      criteria: {
        start_time: new Date(),
        end_time: new Date()
      }
    }
  },
  watch: {
    show() {
      this.showModal = this.show
    }
  },
  async created() {
    this.channels = await ChannelApi.getAll()
    this.initialized = true
  },
  methods: {
    async exportReport() {
      try {
        this.loading = false
        await ScheduleApi.exportCatchup(
          this.criteria.channel.id,
          this.criteria.start_time,
          this.criteria.end_time,
          this.criteria.channel.name
        )
        this.closeModal()
      } catch (err) {
        console.log(err)
        this.$buefy.toast.open({
          message: 'Error exporting schedule',
          position: 'is-top',
          type: 'is-danger'
        })
        this.loading = false
      }
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    }
  }
}
</script>
